
<div class="collapse-container">
  <!-- Use "header-open" and "header-collapsed" to provide different styles / markup for collapsed / not collapsed state-->
  @if (!collapsed) {
    <header class="collapse-header select-none cursor-pointer" (click)="toggle()" [class]="headerClass">
      <ng-content select="header-open"></ng-content>
    </header>
  }
  @if (collapsed) {
    <header class="collapse-header select-none cursor-pointer collapsed" (click)="toggle()" [class]="headerClass">
      <ng-content select="header-collapsed"></ng-content>
    </header>
  }
  <!-- If there's no need for two separate headers use "header-single"-->
  <!--header.collapse-header.select-none.cursor-pointer.collapsed(-->
  <!--    *ngIf="collapsed",-->
  <!--    (click)="toggle()",-->
  <!--    [class]="headerClass",-->
  <!--    [class.collapsed]="collapsed"-->
  <!--)-->
  <!--    ng-content(select="header-single")-->
  @if (!collapsed) {
    <div class="collapse-content">
      <ng-content select="content"></ng-content>
    </div>
  }
</div>